import { render, staticRenderFns } from "./prescriptionDialog.vue?vue&type=template&id=2520a52d&scoped=true&"
import script from "./prescriptionDialog.vue?vue&type=script&lang=js&"
export * from "./prescriptionDialog.vue?vue&type=script&lang=js&"
import style0 from "./prescriptionDialog.vue?vue&type=style&index=0&id=2520a52d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2520a52d",
  null
  
)

export default component.exports